module.exports = __webpack_public_path__ + "img/mb-expDP.b915ae91.svg";